var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M4 3.5C4 3.22386 4.22386 3 4.5 3H7.5C7.77614 3 8 3.22386 8 3.5C8 3.77614 7.77614 4 7.5 4H4.5C4.22386 4 4 3.77614 4 3.5Z",
      fill: "currentColor"
    }, null, -1),
    createElementVNode("path", {
      d: "M9.5 11C10.3284 11 11 10.3284 11 9.5V4.41421C11 4.01639 10.842 3.63486 10.5607 3.35355L8.64645 1.43934C8.36514 1.15804 7.98361 1 7.58579 1H2.5C1.67157 1 1 1.67157 1 2.5V9.5C1 10.3284 1.67157 11 2.5 11H9.5ZM2.5 2H7.58579C7.71839 2 7.84557 2.05268 7.93934 2.14645L9.85355 4.06066C9.94732 4.15443 10 4.2816 10 4.41421V9.5C10 9.77614 9.77614 10 9.5 10H9V9C9 7.89543 8.10457 7 7 7H5C3.89543 7 3 7.89543 3 9V10H2.5C2.22386 10 2 9.77614 2 9.5V2.5C2 2.22386 2.22386 2 2.5 2ZM8 10H4V9C4 8.44772 4.44772 8 5 8H7C7.55228 8 8 8.44771 8 9V10Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
__name(render, "render");
const save = markRaw({ name: "custom-save", render });
export {
  save as default
};
//# sourceMappingURL=save.js.map
